import React, { useEffect } from "react";

import {
  useNotify,
  fetchStart,
  fetchEnd,
  useDataProvider,
  useAuthenticated,
  useQueryWithStore,
  useRedirect,
  Loading,
  AutocompleteArrayInput,
} from "react-admin";
import Parse from "parse";
import { TextField, Select } from "final-form-material-ui";
import { useDispatch } from "react-redux";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { Form, Field } from "react-final-form";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { makeStyles } from "@material-ui/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { useHistory } from "react-router-dom";
import AddCertification from "./AddCertificateDialog";
import { Route } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const useStyle = makeStyles({
  button: {
    color: "#fff",
  },
  loader: {
    color: "#fff",
  },
  desc: {
    width: "50vw",
  },
});

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const MentorDetails = (props) => {
  useAuthenticated();
  const uid = localStorage.getItem("user");

  const { data } = useQueryWithStore({
    type: "getOne",
    resource: "User",
    payload: { id: uid },
  });
  delete data["availability"];
  const history = useHistory();
  const classes = useStyle();
  const notify = useNotify();
  const dispatch = useDispatch();
  const dataProvider = useDataProvider();
  const redirectTo = useRedirect();
  const [loading, setLoading] = React.useState(false);
  const [certificateLoading, setCertificateLoading] = React.useState(false);
  const currentUser = Parse.User.current();
  const [CertificateList, setCertificateList] = React.useState();

  const [notification, setNotification] = React.useState({
    open: false,
    type: "info",
    message: "",
  });

  const OnSubmit = async (values) => {
    setLoading(true);
    let submitflag = true;
    if (!values.description) {
      notify("Kindly fill in the Description. Max 250 chars");
      submitflag = false;
    }
    if (!values.industry) {
      notify("Kindly select the Industry");
      submitflag = false;
    }
    if (submitflag) {
      dataProvider
        .update("User", {
          id: uid,
          data: values,
        })
        .then(
          (success) => {
            setLoading(false);
            setNotification({
              open: true,
              type: "success",
              message: "Mentor Details Updated Successfully",
            });
          },
          (error) => {
            setLoading(false);
            setNotification({
              open: true,
              type: "error",
              message: "Something went wrong. Please retry",
            });
          }
        );
    }
  };

  const validate = (values) => {
    const errors = {};
    if (!values.description) {
      errors.description = "Required";
    } else if (values.description.length > 250) {
      errors.description = "Max 250 characters ";
    }
    if (!values.industry) {
      errors.industry = "Required";
    }

    return errors;
  };

  const industries = useQueryWithStore({
    type: "getList",
    resource: "Industry",
    payload: {
      filter: {},
      pagination: { page: 1, perPage: 10 },
      sort: { field: "Category", order: "asc" },
    },
  });

  const certifications = useQueryWithStore({
    type: "getList",
    resource: "Certification",
    payload: {
      filter: {},
      pagination: { page: 1, perPage: 10000 },
      sort: { field: "", order: "asc" },
    },
  });

  async function handleDeleteCertificate(certificate) {
    try {
      dispatch(fetchStart());
      setCertificateLoading(true);
      const DeleteCertificate = await Parse.Cloud.run("DeleteCertificate", {
        certificate: JSON.stringify(certificate),
      });
      if (DeleteCertificate) {
        notify("Certificate Deleted Successfully");
        dispatch(fetchEnd());
        setCertificateLoading(false);
        redirectTo("/myprofile");
      }
    } catch (e) {
      notify(e.message, "warning");
      setCertificateLoading(false);
      redirectTo("/myprofile");
    } finally {
      dispatch(fetchEnd());
      setCertificateLoading(false);
      redirectTo("/myprofile");
    }
  }

  useEffect(() => {
    setCertificateLoading(true);
    setCertificateList(null);
    const CertificateFile = Parse.Object.extend("CertificateFile");
    const query = new Parse.Query(CertificateFile);
    query.equalTo("mentorId", currentUser);
    const result = query.find();
    result.then(
      (resp) => {
        setCertificateList(
          resp.map((value) => ({
            id: value.id,
            ...value.attributes,
          }))
        );
        setCertificateLoading(false);
      },
      (err) => {
        setCertificateList(err);
        setCertificateLoading(false);
      }
    );
  }, [currentUser, props.location]);

  return (
    <div>
      <Route
        path="/myprofile/addcertificates"
        component={AddCertification}
        noLayout
      />
      ,
      {industries.loaded && certifications.loaded ? (
        <div>
          <Form
            onSubmit={OnSubmit}
            initialValues={data}
            validate={validate}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit} noValidate>
                <Grid
                  container
                  direction="column"
                  justify="flex-start"
                  alignItems="flex-start"
                  spacing={2}
                >
                  <Grid item>
                    <Field
                      xs={12}
                      fullWidth
                      required
                      name="description"
                      component={TextField}
                      type="text"
                      label="Description"
                      className={classes.desc}
                      multiline
                      size="small"
                    />
                  </Grid>
                  <Grid item>
                    <Field
                      xs={12}
                      fullWidth
                      required
                      name="mentorFee"
                      component={TextField}
                      type="text"
                      label="Mentor Fee"
                      className={classes.desc}
                      multiline
                      size="small"
                    />
                  </Grid>
                 
                  
                  <Grid item>
                    <Field
                      item
                      xs={12}
                      name="industry"
                      component={Select}
                      label="Industry"
                      required
                      style={{
                        width:"24vh"
                      }}
                    >
                      {industries.data.map((industry) => (
                        <MenuItem value={industry.Category}>
                          {industry.Category}
                        </MenuItem>
                      ))}
                    </Field>
                  </Grid>
                  <Grid item>
                    <AutocompleteArrayInput
                      xs={12}
                      source="Certification"
                      label="Certification"
                      variant="standard"
                      fullWidth
                      choices={
                        certifications.loaded
                          ? certifications.data.map((r) => ({
                              id: r.id,
                              name: r.certificateName,
                            }))
                          : []
                      }
                      optionValue="name"
                    />
                  </Grid>
                  <Grid item style={{ marginTop: "-4vh", marginLeft: "-2vh" }}>
                    <Tooltip title="Attach your certificates">
                      <Button
                        disabled={
                          CertificateList !== undefined &&
                          CertificateList !== null &&
                          certificateLoading === false &&
                          CertificateList.length === 5
                            ? true
                            : false
                        }
                        onClick={() => {
                          history.push({
                            pathname: "/myprofile/addcertificates",
                          });
                        }}
                      >
                        <AttachFileIcon />
                      </Button>
                    </Tooltip>
                  </Grid>
                  <div>
                    {CertificateList !== undefined &&
                      CertificateList !== null &&
                      certificateLoading === false &&
                      CertificateList.map((certificate) => (
                        <div
                          style={{
                            position: "relative",
                          }}
                        >
                          <Table>
                            <TableBody>
                              <TableRow>
                                <TableCell>
                                  {certificate.certificateName}
                                </TableCell>
                                <TableCell>
                                  <IconButton
                                    aria-label="close"
                                    style={{
                                      position: "absolute",
                                      right: -10,
                                      top: 7,
                                    }}
                                    onClick={() =>
                                      handleDeleteCertificate(certificate)
                                    }
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </div>
                      ))}
                  </div>
                  <Grid item style={{ marginTop: 16 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={loading}
                      className={classes.button}
                    >
                      {!loading ? "Submit" : <CircularProgress />}
                    </Button>
                  </Grid>
                </Grid>
                <Snackbar open={notification.open} autoHideDuration={800}>
                  <Alert severity={notification.type}>
                    {notification.message}
                  </Alert>
                </Snackbar>
              </form>
            )}
          />
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default MentorDetails;
